import { Component, OnInit, OnDestroy } from '@angular/core';
import { AbTestingApiService } from '@app/pages/checkout-app/services/api/abtesting.api.service';
import { Subscription } from 'rxjs';

interface ImpactOverviewResponse {
  AB_TEST_ANNUALIZE_IMPACT_REVENUE?: number;
}

@Component({
  selector: 'impact-dashboard',
  standalone: false,
  templateUrl: './impact-dashboard.component.html',
  styleUrl: './impact-dashboard.component.scss',
})
export class ImpactDashboardComponent implements OnInit, OnDestroy {
  loading = true;
  hasAnnualizedRevenue = false;
  private subscription: Subscription | null = null;

  constructor(private abTestingApiService: AbTestingApiService) {}

  ngOnInit(): void {
    this.checkForAnnualizedRevenue();
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  private checkForAnnualizedRevenue(): void {
    this.loading = true;
    this.subscription = this.abTestingApiService.get('ab-tests/impact-overview-metric').subscribe({
      next: (response: ImpactOverviewResponse | null) => {
        this.hasAnnualizedRevenue = (response?.AB_TEST_ANNUALIZE_IMPACT_REVENUE ?? 0) > 0;
        this.loading = false;
      },
      error: () => {
        this.hasAnnualizedRevenue = false;
        this.loading = false;
      },
    });
  }
}
